import React from 'react';
import { connect } from 'react-redux';
import { withRouter, WithRouterProps } from 'react-router';
import { Actions } from '../actions';

interface ChildrenFn {
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

interface Props {
  children: (args: ChildrenFn) => React.ReactNode;
  onShowAuthModal: typeof Actions.showModal;
  onCloseMobileDrawer: () => void;
}

export class AuthModalActions extends React.Component<Props & WithRouterProps> {
  handleRegisterClick = () => {
    const {
      onCloseMobileDrawer,
      onShowAuthModal,
      location: { pathname },
    } = this.props;
    onCloseMobileDrawer();
    onShowAuthModal('register', pathname);
  };

  handleLoginClick = () => {
    const {
      onCloseMobileDrawer,
      onShowAuthModal,
      location: { pathname },
    } = this.props;
    onCloseMobileDrawer();
    onShowAuthModal('login', pathname);
  };

  render() {
    const { children } = this.props;

    return children({
      onLoginClick: this.handleLoginClick,
      onRegisterClick: this.handleRegisterClick,
    });
  }
}

export default connect(null, {
  onShowAuthModal: Actions.showModal,
  onCloseMobileDrawer: Actions.closeMobileDrawer,
})(withRouter(AuthModalActions));
